import IState from './Istate'
const currentDate = new Date();
let currentMonth: number|string = currentDate.getMonth() + 1;
currentMonth = currentMonth >= 10 ? currentMonth : '0' + currentMonth;
const DEFAULT_SPEAKER = {
  "id": 416,
  "wwid": "15a9c73845d04424a316ff0cff16f49f",
  "speaker": "m091_lpcnet_24k",
  "name": "魔天轮",
  "headerImage": "https://mobvoi-backend-public.ticwear.com/headerImage/png/9241b691-72b7-44a5-947b-dcd1b050613c2x.png",
  "introduction": "",
  "characteristic": "",
  "vipAuth": 1,//svip拥有
  "level": "open",
  "age": "ADULT",
  "specificAge": 30,
  "specificLanguage": "普通话",
  "gender": "MALE",
  "createdAt": "2020-01-14T13:46:00.000+0800",
  "updatedAt": "2021-04-26T09:07:30.000+0800",
  "limitFree": false,
  "tags": "热门",
  "pauseMap": "break_prosody,phrase_prosody",
  "vcSpeaker": "m091_24k_vc",
  "likeCount": 0,
  "playCount": 613,
  "followerCount": 0,
  "priceRate": 0,
  "status": "AVAILABLE",
  "version": null,
  "displayOrder": 30,
  "top": 0,
  "source": "问问内部",
  "boutique": null,
  "language": "MANDARIN_CHINESE",
  "speakerSpeed": 5.2,
  "speakerEmotionCacheVOList":[{
    demo: 
    "水深不语人稳不言。口舌之争改变不了任何事实，唯有沉默胜过万语千言。不在别人的评价里乱了节奏，只管在自己的世界中韬光养晦是一个人最大的成熟。",
    demoUrl: 
    "https://mobvoi-speech-public.mobvoi.com/mobvoi-tts/speaker_audios/d78b688c-5503-45d4-84d9-77977cc211e2.wav",
    name: "魔天轮",
    speaker: "m091_meet_24k",
    speaker24k: null,
    speakerId: 416}],
  "speakerFeature": [
      {
          "id": 5,
          "name": "音标"
      },
      {
          "id": 6,
          "name": "局部变速"
      },
      {
          "id": 7,
          "name": "多发音人"
      },
      {
          "id": 8,
          "name": "停顿调节"
      },
      {
          "id": 9,
          "name": "插入静音"
      },
      {
          "id": 10,
          "name": "特效音"
      },
      {
          "id": 11,
          "name": "背景音"
      },
      {
          "id": 12,
          "name": "全局段落静音"
      },
      {
          "id": 13,
          "name": "儿化音"
      },
      {
          "id": 14,
          "name": "变调"
      },
      {
          "id": 15,
          "name": "符号静音"
      },
      {
          "id": 16,
          "name": "全文停顿调节"
      },
      {
          "id": 18,
          "name": "查找替换-多音字"
      },
      {
          "id": 19,
          "name": "重读"
      },
      {
          "id": 0,
          "name": "试听"
      },
      {
          "id": 1,
          "name": "多音字"
      },
      {
          "id": 2,
          "name": "数字符号"
      },
      {
          "id": 3,
          "name": "连读"
      },
      {
          "id": 4,
          "name": "别名"
      }
  ],
  "speakerType": [
      {
          "id": 9,
          "name": "影视解说",
          "createdAt": "2020-01-01T00:30:00.000+0800",
          "updatedAt": "2020-11-09T19:07:50.000+0800",
          "speakers": null
      }
  ],
  "usable": true,
  "styleName": "通用",
  "styleAvatar": "https://mobvoi-backend-public.ticwear.com/headerImage/png/9241b691-72b7-44a5-947b-dcd1b050613c2x.png"
};

let state :IState = {
    currentPageName:"",
    showTab:false,
    accoData:{},
    curAccoData:{},
    cachedKeyboardHeight: 0,
    keyboardTrigger: '', // 键盘触发来源，临时方案，只是因为editor页面是被动接受键盘高度变化，所以非编辑区域的键盘也会影响到editor页面
    vipInfo: null,
    // 所有已购声音列表 包含付费声音、直接购买声音
    boughtSpeakerList: [],
    // 直接购买的发音人列表
    purchasedSpeakerList: [],
    appVersion: '',
    currSpeaker: DEFAULT_SPEAKER,
    // allSpeakersMap: {},//所有发音人{本体:{default:发音人数据,风格1:发音人数据...}
    emotionListMap:{},//{emotionName:风格图片}
    bgmId:'',
    currSpeed:'1.0'
};
export default state;
